import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import GlobalStyles from './styles/globalStyles';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Attractions from './pages/Attractions';
import AttractionDetails from './pages/AttractionDetails';
import CityDetail from './pages/CityDetail';
import Accommodations from './pages/Accommodations';
import Services from './pages/Services';
import ShortTermRentals from './pages/services/ShortTermRentals';
import LongTermRentals from './pages/services/LongTermRentals';
import Auctions from './pages/services/Auctions';
import BuySell from './pages/services/BuySell';
import Events from './pages/services/Events';
import Experiences from './pages/services/Experiences';
import NotFound from './pages/NotFound';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import SEOHelmet from './seo/SEOHelmet';
import { LanguageProvider } from './i18n/LanguageContext';
import CookieConsent from './components/ui/CookieConsent';

// Componente per lo scroll automatico all'inizio della pagina quando si cambia rotta
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Componente per i metadati SEO globali
const GlobalSEO: React.FC = () => {
  return (
    <SEOHelmet
      title="Alloggi"
      description="J-O-H offre servizi di gestione immobiliare di lusso in Toscana e Liguria. Scopri le nostre ville esclusive, appartamenti nel centro storico e case sulla spiaggia."
      schemaType="Organization"
      keywords={[
        'gestione immobiliare', 'immobili di lusso', 'ville in toscana', 
        'case vacanze liguria', 'investimenti immobiliari', 'affitti di lusso'
      ]}
    />
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <GlobalStyles />
        <GlobalSEO />
        <ScrollToTop />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/attractions" element={<Layout><Attractions /></Layout>} />
          <Route path="/attraction-details" element={<Layout><AttractionDetails /></Layout>} />
          <Route path="/accommodations" element={<Layout><Accommodations /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/services/short-term-rentals" element={<Layout><ShortTermRentals /></Layout>} />
          <Route path="/services/long-term-rentals" element={<Layout><LongTermRentals /></Layout>} />
          <Route path="/services/auctions" element={<Layout><Auctions /></Layout>} />
          <Route path="/services/buy-sell" element={<Layout><BuySell /></Layout>} />
          <Route path="/services/events" element={<Layout><Events /></Layout>} />
          <Route path="/services/experiences" element={<Layout><Experiences /></Layout>} />
          <Route path="/citta/:cityId" element={<Layout><CityDetail /></Layout>} />
          <Route path="/terms-of-service" element={<Layout><TermsOfService /></Layout>} />
          <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/cookie-policy" element={<Layout><CookiePolicy /></Layout>} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

export default App;
